import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgModule } from '@angular/core';
import { StoreModule, MetaReducer } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { environment } from 'src/environments/environment';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { CustomRouterSerializer } from './reducers/router.reducer';
import { rootReducers } from './reducers';
import { rootEffects } from './effects';


const metaReducers: MetaReducer<any>[] = [];


@NgModule({
  declarations: [],
  imports: [
    StoreModule.forRoot(rootReducers, { metaReducers }),
    EffectsModule.forRoot(rootEffects),

    StoreRouterConnectingModule.forRoot({
      serializer: CustomRouterSerializer
    }),

    environment.production ? [] : StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
      name: 'Gioco-store'
    })
  ]
})
export class RootStoreModule { }
